import styles from "./PostStatusFeedback.module.css";
import Loader from "./Loader";

export default function PostStatusFeedback({
  respStatus = 0,
  success = "Uspješno poslano!",
  fail = "Greška! Pokušajte kasnije.",
}) {
  return (
    <>
      {respStatus !== 0 && (
        <div className={styles.container}>
          {respStatus === 1 && (
            <div className={styles.content}>
              <Loader />
            </div>
          )}
          {respStatus === 2 && (
            <div className={`${styles.content} ${styles.message}`}>
              {success}
            </div>
          )}
          {respStatus === -1 && (
            <div className={`${styles.content} ${styles.message}`}>{fail}</div>
          )}
        </div>
      )}
    </>
  );
}
